<script>
  import { auth, db, fstore } from "../etc/firebase.js"
  import {
    userStore,
    userGuaCount,
    guaRecordStore,
    selectedLanguage,
  } from "../etc/store.js"
  import {
    btn_style_yellow_d2,
    btn_style_blue_d2,
    btn_style_teal,
    btn_style_orange_d2,
    xiyiSalt,
  } from "../etc/helpers.js"
  import PlsGoHome from "./PlsGoHome.svelte"

  let transactionDetails = {}
  let transactionRecords = []
  let aDayinMs = 24 * 60 * 60 * 1000
  let aYearinDays = 365.25
  let timeToExpiration = 0
  let timeToExpirationNew = 0
  let addedDays = 0
  let isLogin = false
  let myName = ""
  let mySchool = ""
  let myMajor = ""
  let myYear = ""
  let myReasons = ""
  let adminNote = ""
  let termBasePrice = 60
  let amount = 0
  let docId = ""
  let showSuccessPage = false
  let userObj = {}

  auth.onAuthStateChanged((user) => {
    if (user) {
      isLogin = true

      // console.log("@ SuccessOrder: getting user.uid = ", user.uid)

      db.collection("xiyiMembers")
        .where("firebaseUid", "==", user.uid)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // console.log(doc.id, " => ", doc.data())
            // Step 3: check if this is real transaction with correct attribute values
            if (doc.data().paymentIntent == true) {
              showSuccessPage = true
              if (doc.data().intendedMemberType == "一般會員") {
                amount = doc.data().intendedTerm * termBasePrice
              } else {
                myName = doc.data().schoolInfo.myName
                mySchool = doc.data().schoolInfo.mySchool
                myMajor = doc.data().schoolInfo.myMajor
                myYear = doc.data().schoolInfo.myYear
                myReasons = doc.data().schoolInfo.myReasons
                amount = termBasePrice
              }

              // Build current transaction record
              transactionDetails = {
                transactionDT: doc.data().paymentIntentDT,
                term: doc.data().intendedTerm,
                memberType: doc.data().intendedMemberType,
                amount: amount,
                firebaseUid: doc.data().firebaseUid,
                userName: doc.data().userName,
                myName: myName,
                mySchool: mySchool,
                myMajor: myMajor,
                myYear: myYear,
                myReasons: myReasons,
                currencyType: doc.data().currencyType,
                payment_status: "paid",
                adminNote: adminNote,
              }

              // console.log(
              //   "@ SuccessOrder: transactionDetails created with 'paid' paymentStatus ",
              //   transactionDetails
              // )

              if ($userStore.userInfo.transactionRecords == undefined) {
                transactionRecords = []
              } else {
                transactionRecords = [...$userStore.userInfo.transactionRecords]
              }

              timeToExpiration = $userStore.userInfo.timeToExpiration
              addedDays = aYearinDays * doc.data().intendedTerm
              timeToExpirationNew = timeToExpirationNew + addedDays
              // console.log("@ SuccessOrder: addedDays = ", addedDays)
              transactionRecords.push(transactionDetails)
              docId = $userStore.userInfo.docId
              // console.log(
              //   "@ SuccessOrder: about to update : memberType = ",
              //   doc.data().intendedMemberType
              // )
              // console.log(
              //   "@ SuccessOrder: about to update : lastPayment = ",
              //   amount
              // )
              // console.log(
              //   "@ SuccessOrder: about to update : subscriptionExpireOn = ",
              //   doc.data().subscriptionExpireOn +
              //     aDayinMs * aYearinDays * doc.data().intendedTerm
              // )
              // console.log(
              //   "@ SuccessOrder: about to update : transactionRecords = ",
              //   transactionRecords
              // )

              // update XiYiMember transaction record
              // Important!! Need to reset payment process to false to prevent account issue.
              db.collection("xiyiMembers")
                .doc(docId)
                .update({
                  //.set({
                  memberType: doc.data().intendedMemberType,
                  lastPayment: amount,
                  subscriptionExpireOn:
                    doc.data().subscriptionExpireOn +
                    aDayinMs * aYearinDays * doc.data().intendedTerm,
                  transactionRecords: transactionRecords,
                  paymentIntentDT: 0,
                  paymentIntent: false,
                  intendedMemberType: "",
                  intendedTerm: "",
                  //transactionRecords: fstore.FieldValue.arrayUnion(
                  //  transactionDetails
                  //),
                })
                .then(() => {
                  // console.log(
                  //   "@ SuccessOrder: firebase XiYiMembers db updated with the new transaction info."
                  // )

                  // Then, need to update userStore.UserInfo
                  db.collection("xiyiMembers")
                    .where("firebaseUid", "==", user.uid)
                    .get()
                    .then((querySnapshot) => {
                      querySnapshot.forEach((doc) => {
                        //console.log(doc.id, " => ", doc.data())
                        userObj = {
                          docId: doc.id,
                          firebaseUid: user.uid,
                          createdDT: doc.data().createdDT,
                          userName: doc.data().userName,
                          userAlias: doc.data().userAlias,
                          email: doc.data().email,
                          country: doc.data().country,
                          city: doc.data().city,
                          phone: doc.data().phone,
                          paymentIntent: doc.data().paymentIntent,
                          subscriptionBeginOn: doc.data().subscriptionBeginOn,
                          subscriptionExpireOn: doc.data().subscriptionExpireOn,
                          lastPayment: doc.data().lastPayment,
                          currencyType: doc.data().currencyType,
                          qiMonthlyGoal: doc.data().qiMonthlyGoal,
                          memberType: doc.data().memberType,
                          transactionRecords: doc.data().transactionRecords,
                          timeToExpiration:
                            (doc.data().subscriptionExpireOn -
                              new Date().getTime()) /
                            (1000 * 60 * 60 * 24),
                        }
                      })
                    })

                  $userStore.userInfo = userObj
                  // console.log(
                  //   "@ SuccessOrder.onAuthStateChanged just updated $userStore.userInfo = ",
                  //   $userStore.userInfo
                  // )
                })
                .catch(() => {
                  console.log(
                    "@ SuccessOrder: firebase XiYiMembers db updated failed!"
                  )
                })
            } else {
              showSuccessPage = false
              //  console.log("@ SuccessOrder: fake transaction. Show PlsGoHome")
            }
          })
        })
        .catch(() => {
          console.log("@ SuccessOrder: Error getting XiYiMembers documents: ")
        })
    } else {
      isLogin = false
      // console.log(
      //   "@ XiYiAdmin: just logout. System will redirect user to Private page and asking for login first."
      // )
    }
  })

  const handleRedirect = (where) => {
    if (where == "home") {
      location.assign("/")
    } else {
      location.assign("/account")
    }
  }

  //   function handleSuccessRedirect() {
  //     setTimeout(function () {
  //       alert("Checking account status...")
  //     }, 2000)
  //     if (showSuccessPage == false) location.assign("/")
  //   }
</script>

{#if showSuccessPage == true}
  {#if $selectedLanguage == "TW"}
    <main>
      <div class="row">
        <div class="col s12 m12 l12">
          <div class="card-panel amber lighten-5">
            <h3>謝謝您！您已經付款成功！</h3>

            <h4>
              目前，您的會員有效日還有【{Math.round(
                (timeToExpirationNew + Number.EPSILON) * 100
              ) / 100}】天
            </h4>
            <br />
            <div class="btn-row center">
              <button
                class="btn btn-large blue"
                on:click={() => handleRedirect("home")}>回主頁</button
              >
              <button
                class="btn btn-large orange"
                on:click={() => handleRedirect("account")}>回帳戶</button
              >
            </div>
          </div>
        </div>
      </div>
    </main>
  {:else}
    <main>
      <div class="row">
        <div class="col s12 m12 l12">
          <div class="card-panel amber lighten-5">
            <h3>谢谢您！您已经付款成功！</h3>

            <h4>
              目前，您的会员有效日还有{Math.round(
                (timeToExpiration + Number.EPSILON) * 100
              ) /
                100 +
                addedDays}天
            </h4>
            <br />
            <div class="btn-row center">
              <button
                class="btn btn-large blue"
                on:click={() => handleRedirect("home")}>回主页</button
              >
              <button
                class="btn btn-large orange"
                on:click={() => handleRedirect("account")}>回帐户</button
              >
            </div>
          </div>
        </div>
      </div>
    </main>
  {/if}
{:else}
  <PlsGoHome />
{/if}

<style>
  .btn {
    margin-left: 10px;
    margin-right: 10px;
  }
</style>
